import { DocumentStages } from "../../../graphql/__GENERATED__/types";
import { ColorNames } from "../../../theme";

export type TChartCard = {
  color: ColorNames;
  category: DocumentStages;
  groupFilter: [string, string];
  buttonFilters: [string, string[]];
};

export const documentsCharts: TChartCard[] = [
  {
    category: DocumentStages.Simulation,
    color: ColorNames.GREEN,
    groupFilter: ["etapa", "cotacao"],
    buttonFilters: [
      "status",
      ["pendentes", "finalizadas", "enviadas", "expiradas"],
    ],
  },
  {
    color: ColorNames.PINK,
    category: DocumentStages.Proposal,
    groupFilter: ["etapa", "proposta"],
    buttonFilters: [
      "status",
      ["incompletas", "pendentes", "finalizadas", "enviadas"],
    ],
  },
  {
    color: ColorNames.BLUE,
    category: DocumentStages.Policy,
    groupFilter: ["etapa", "apolice"],
    buttonFilters: ["status", ["pendentes", "finalizadas", "vigentes"]],
  },
  {
    color: ColorNames.ORANGE,
    category: DocumentStages.Claim,
    groupFilter: ["etapa", "sinistro"],
    buttonFilters: ["status", ["pendentes", "em analise"]],
  },
];
